import { URLS as COMPETENCIA_URL } from "#competence/urls"
import { MODULES } from "#constants/modules"
import PERMISOS from "#constants/perfiles"
import JobProfiles from "#job-profile/pages/JobProfiles"
import SavingsFund from "#savings-fund/pages/SavingsFund"
import VacationBoss from "#vacation/pages/VacationBoss"
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket"
import CheckroomIcon from "@mui/icons-material/Checkroom"
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange"
import MoneyIcon from "@mui/icons-material/Money"
import PeopleIcon from "@mui/icons-material/People"
import PersonAddIcon from "@mui/icons-material/PersonAdd"
import PersonOffIcon from "@mui/icons-material/PersonOff"
import PointOfSaleIcon from "@mui/icons-material/PointOfSale"
import SavingsIcon from "@mui/icons-material/Savings"
import SolicitudesBajas from "Components/bajas/SolicitudesBajas"
import Colaboradores from "Components/Colaboradores/pages/Colaboradores"
import Promotions from "Components/promotions/Promotions"
import { URLS as DOCUMENTS_URL } from "modules/documents-society/urls"
import { URLS as SALARIES_URL } from "modules/salaries/urls"
import { URLS as TRAINING_URL } from "modules/training/urls"
import { URLS as PERFORMANCE_EVALUATION_URL } from "#performance-evaluation/urls"
import PrestamosSolicitudes from "../../Pages/PrestamosSolicitudes"
import TuPerfil from "../../Pages/TuPerfil"
import Uniformes from "../../Pages/Uniformes"
import FondoFijo from "../FondoFijo/FondoFijo"
import Pagos from "../pagos/Pagos"
import Ruta404 from "./Ruta404"

import CandidateDetails from "#candidate/pages/CandidateDetails"
import { default as EvaluationInterview } from "#evaluation/pages/EvaluationInterview"
import Vacancy from "#vacancy/pages/Vacancy"
import BadgeIcon from "@mui/icons-material/Badge"
import Form from "#performance-evaluation/pages/Form"
const {
	// ...RH_ALL,
	GRTE,
	SISTEMAS,
	JEFATURA,
	PAGOS,
	COMPRAS,
	CONTABILIDAD,
	GUATEMALA,
	MANTENIMIENTO,
	JEFE_NOMINAS,
	GRTE_RH,
	RH_ALL,
	RH,
} = PERMISOS

export const rutasItems = {
	rutas: [
		//!siempre debe ser el primer item los que no tiene que aparecer en el menu
		{
			path: "/",

			element: <TuPerfil />,
		},
		{
			path: "perfil",
			element: <TuPerfil />,
		},

		{
			path: "*",
			element: <Ruta404 />,
		},
		{
			path: "candidate/:candidateId",
			element: <CandidateDetails />,
		},
		{
			path: "candidate/:candidateId/evaluation",
			element: <EvaluationInterview />,
		},
		{
			path: "performance_evaluation/form",
			element: <Form />,
			subPath: "evaluationEvaluatorId",
		},
	],

	Colaboradores: [
		{
			path: "colaboradores",
			title: "Colaboradores",
			module: MODULES.COLABORADOR,
			element: <Colaboradores />,
			icon: PeopleIcon,
			permissions: [...RH_ALL, SISTEMAS, JEFE_NOMINAS],
			subPath: "no_empleado",
		},
		{
			path: "promociones",
			title: "Promociones",
			module: MODULES.PROMOTIONS,
			element: <Promotions />,
			permissions: [...RH_ALL, GRTE, JEFATURA],
			icon: PersonAddIcon,
			subPath: "promotionsId",
		},
		{
			path: "bajas",
			module: MODULES.BAJAS,

			title: "Bajas de Colaborador",
			element: <SolicitudesBajas />,
			icon: PersonOffIcon,
			permissions: [...RH_ALL, CONTABILIDAD, SISTEMAS, GRTE, MANTENIMIENTO, JEFE_NOMINAS],
			notification: "bajas",
		},
		{
			path: "vacancy",
			title: "Vacantes",
			module: MODULES.VACANTES,
			element: <Vacancy />,
			permissions: [...RH_ALL, GRTE, JEFATURA],
			icon: PersonAddIcon,
			notification: "requerimientos",
			subPath: "vacanteId",
		},
		{
			module: MODULES.PERFIL_PUESTO,
			path: "perfil-puesto",
			element: <JobProfiles />,
			title: "Perfil Puesto",
			icon: BadgeIcon,
			permissions: [PERMISOS.RH, PERMISOS.GRTE, PERMISOS.JEFATURA],
			textDivider: "perfil-puesto",
			subPath: "id",
		},
	],
	Competencias: [...COMPETENCIA_URL],

	...TRAINING_URL,

	Solicitudes: [
		{
			module: MODULES.PRESTAMOS,
			path: "prestamos",
			title: "Prestamos",
			element: <PrestamosSolicitudes />,
			icon: MoneyIcon,
			permissions: [...RH_ALL, GRTE],
			denied: [GUATEMALA],
			textDivider: "Solicitudes",
		},
		{
			module: MODULES.CAJA_AHORRO,
			path: "caja-ahorro",
			title: "Caja Ahorro",
			element: <SavingsFund />,
			icon: SavingsIcon,
			denied: [GUATEMALA],
			permissions: [...RH_ALL],
			notification: "caja_ahorro",
		},
		{
			module: MODULES.FONDO_FIJO,
			path: "fondo-fijo",
			title: "Fondo Fijo",
			element: <FondoFijo />,
			icon: PointOfSaleIcon,
			permissions: [...RH_ALL, PAGOS, CONTABILIDAD, GRTE],
			// denied: [GUATEMALA],
		},
		{
			module: MODULES.UNIFORMES,
			path: "uniformes",
			title: "Uniformes",
			element: <Uniformes />,
			icon: CheckroomIcon,
			permissions: [...RH_ALL, COMPRAS],
			denied: [GUATEMALA],
		},
		{
			module: MODULES.VACACIONES,
			path: "vacaciones",
			title: "Vacaciones",
			element: <VacationBoss />,
			icon: AirplaneTicketIcon,
			permissions: [RH, GRTE, JEFATURA],
		},
	],
	...PERFORMANCE_EVALUATION_URL,
	Contabilidad: [
		{
			module: MODULES.PAGOS,
			path: "pagos",
			title: "Pagos",
			element: <Pagos />,
			icon: CurrencyExchangeIcon,
			permissions: [PAGOS, GRTE_RH],
			textDivider: "Información Lubtrac",
			notification: "pagos",
		},
	],

	...SALARIES_URL,
	...DOCUMENTS_URL,
}
